export default "__VITE_ASSET__DZmJ1sKr__"